export const subregionKey = 'Subregion';
export const regionKey = 'Region';
export const countryKey = 'Country of Implementation';
export const implementerKey = 'Un Host Organisation';
export const sdgKey = 'SDG';
export const yearKey = 'Date of Implementation';
export const dataKey = 'Data';
